export default {
  chainManage: () => import('./chainManage/index.vue'), // 经营统计
  chainDrugSale: () => import('./chainDrugSale/index.vue'), // 药品销售统计
};
